
"use strict"; // jshint ignore:line

export default function PreviewModelService( $rootScope,  $http,  $q,  $location,  ipCookie,  Notification,  $User,  $ApiHandler ) {

	var self = this;
	this.models = {};

	this.fetchPreviewModels = $ApiHandler.fetchPreviewModels = fetchPreviewModels;
	function fetchPreviewModels(){
		return $ApiHandler.get("/model_preview/models", {
			with: "arrangements",
			filters: "onlydata,onlyattrs"
		}).catch(function( err ){
			console.error( err );
			return { data: {} };
		}).then(function( response ){
			for( var uid in response.data ) self.models[ uid ] = response.data[ uid ] = new PreviewModel( response.data[ uid ]);
			return response.data;
		});
	}

	/******************************/

	this.fetchPreviewModel = $ApiHandler.fetchPreviewModel = fetchPreviewModel;
	function fetchPreviewModel( uid, noArrangement){
		return $ApiHandler.get("/model_preview/models/"+uid, {
			with    : noArrangement ? "" : "arrangements",
			filters : "asarray,onlydata,onlyattrs"
		}).then(function( response ){
			return new PreviewModel( response.data[ 0 ]);
		});
	}

	/******************************/

	this.uploadNewPreviewModel = uploadNewPreviewModel;
	$ApiHandler.uploadNewPreviewModel = function( data ){
		return uploadNewPreviewModel( data );
	}
	function uploadNewPreviewModel( data ){
		return $ApiHandler.post("/model_preview/models/", {}, {
			"model_preview_model.owner_uid" : $User.uid,
			"model_preview_model.title"     : data.title    || "",
			"model_preview_model.config"    : data.config   || {},
			"model_preview_model.filename"  : data.filename || "",
			"model_preview_model.format"    : data.format   || "",
		}).then(function( response ){
			console.log( response );
			return fetchPreviewModel( $ApiHandler.getParsedLocation( response ).href.substr( -16 ));
		});
	}

	/******************************/


	this.updateSavedPreviewModel = updateSavedPreviewModel;
	$ApiHandler.updateSavedPreviewModel = function( uid, data ){
		return updateSavedPreviewModel( uid, data );
	};
	function updateSavedPreviewModel( uid, data ){
		return $ApiHandler.post("/model_preview/models/"+ uid, {}, updateSavedPreviewModel.data2Body( uid, data ));
	}
	updateSavedPreviewModel.data2Body = function( uid, data ){
		var body = { "model_preview_model.uid": uid };
		if (data.title)  body["model_preview_model.title"] = data.title;
		if (data.config) {
			body["model_preview_model.config"] = {
				default_source      : data.config.default_source,
				default_url         : data.config.default_url,
				attachment_uid      : data.config.attachment_uid      || undefined,
				filename            : data.config.filename            || undefined,
				filesize            : data.config.filesize            || undefined,
				default_arrangement : data.config.default_arrangement || undefined,
				model_scale         : data.config.model_scale         || undefined,
				additional_objects  : data.config.additional_objects  || {}
			};

			if (data.config.player) {
				body["model_preview_model.config"].player = {
					ah     : data.config.player.ah || undefined,
					av     : data.config.player.av || undefined,
					pos    : data.config.player.pos && (Array.isArray(data.config.player.pos) ? data.config.player.pos : data.config.player.pos.toArray()),
					height : data.config.player.height || undefined
				};
			}
		}
		return body;
	};
}

PreviewModelService.$inject = ["$rootScope","$http","$q","$location","ipCookie","Notification","$User","$ApiHandler"];

export function PreviewModel( data ){
	if( data instanceof PreviewModel ) return data;

	this.$raw       = data = data || {};
	this.with       = data.with || {};

	this.uid        = data.uid       || null;
	this.owner_uid  = data.owner_uid || null;

	this.title      = data.title     || "";
	this.filename   = data.filename  || "";
	this.format     = data.format    || "";

	this.created_at = data.created_at ? new Date( data.created_at ) : new Date();
	this.updated_at = data.updated_at ? new Date( data.updated_at ) : new Date();

	this.config     = data.config    || {};
	this.$mappings  = data.$mappings || {};
	this.$access    = parseInt( data.$access );

	if (typeof this.config.additional_objects == "string") {
		try {
			this.config.additional_objects = JSON.parse( this.config.additional_objects );
		} catch (err) {
			console.error( err );
		}
	}
	this.additional_objects = this.config.additional_objects = this.config.additional_objects || {};

	if( isNaN( this.$access )) this.$access = 0;
}
